<div class="prev-next-container">
   <ctp-button (click)="previous()" [style]="'secondary'" [ngClass]="previousHidden" i18n>Previous</ctp-button>
   <ctp-button (click)="next()" [style]="'primary'" [ngClass]="nextHidden">{{nextMessage}}</ctp-button>
</div>
